<template>
    <div>
        <webview allowpopups v-if="asyncShow" :useragent="userAgent" class="flex1" ref="webview" :src="src"
            nodeintegration disablewebsecurity nodeintegrationinsubframes :webPreferences="webPreferences"
            :partition="webviewKey" :preload="preloadFile" :style="style">
        </webview>
    </div>
</template>
<script>
import $mywebviewnowin from "@/views/admin/webview/mywebviewnowin.js";
export default {
    mixins: [
        $mywebviewnowin
    ]
}
</script>
<style scoped></style>